export const normalizeCallStatus = (rawStatus) => {
  if (!rawStatus) return null;
  const statusStr = String(rawStatus).toLowerCase().trim();
  switch (statusStr) {
    case 'chamado':
    case 'chamando':
    case 'calling':
      return 'calling';
    case 'na sala':
    case 'na_sala':
    case 'arrived':
      return 'arrived';
    case 'atendido':
    case 'finalizado':
    case 'concluido':
      return 'done';
    case 'expirado':
    case 'expired':
      return 'expired';
    default:
      return statusStr;
  }
};
